import classnames from 'classnames'
import React, { forwardRef } from 'react'
import { noop } from 'utils'

// import './style.css' // moved to App/index.tsx

const NakedButton = forwardRef(({ className, children, ...rest }: any, ref: any) => (
  <button
    className={classnames("drift-widget-naked-button", {
      [className]: !!className
    })}
    ref={ref}
    onTouchStart={noop}
    {...rest}
  >
    {children}
  </button>
))

export default NakedButton
